// src/pages/Logs.js
import React, { useEffect, useState } from 'react';
import { Container, Form, Button, Table, Pagination } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLogs } from '../redux/actions/logActions';

function Logs() {
  const dispatch = useDispatch();
  const { logs, totalPages } = useSelector((state) => state.log);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [userId, setUserId] = useState('');
  const [requestType, setRequestType] = useState('');
  const [responseType, setResponseType] = useState('');
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(fetchLogs({ startDate, endDate, userId, requestType, responseType, page }));
  }, [dispatch, startDate, endDate, userId, requestType, responseType, page]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    dispatch(fetchLogs({ startDate, endDate, userId, requestType, responseType, page: 1 }));
  };

  const paginationItems = [];
  for (let number = 1; number <= totalPages; number++) {
    paginationItems.push(
      <Pagination.Item key={number} active={number === page} onClick={() => setPage(number)}>
        {number}
      </Pagination.Item>
    );
  }

  return (
    <Container className="mt-4">
      <h2>Logs</h2>
      <Form onSubmit={handleSearch} className="mb-3">
        <Form.Group controlId="startDate" className="mb-2">
          <Form.Label>Start Date</Form.Label>
          <Form.Control type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </Form.Group>
        <Form.Group controlId="endDate" className="mb-2">
          <Form.Label>End Date</Form.Label>
          <Form.Control type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </Form.Group>
        <Form.Group controlId="userId" className="mb-2">
          <Form.Label>User ID</Form.Label>
          <Form.Control type="text" placeholder="Enter User ID" value={userId} onChange={(e) => setUserId(e.target.value)} />
        </Form.Group>
        <Form.Group controlId="requestType" className="mb-2">
          <Form.Label>Request Type</Form.Label>
          <Form.Control type="text" placeholder="Enter Request Type" value={requestType} onChange={(e) => setRequestType(e.target.value)} />
        </Form.Group>
        <Form.Group controlId="responseType" className="mb-2">
          <Form.Label>Response Type</Form.Label>
          <Form.Control type="text" placeholder="Enter Response Type" value={responseType} onChange={(e) => setResponseType(e.target.value)} />
        </Form.Group>
        <Button variant="primary" type="submit" className="mt-2">
          Search
        </Button>
      </Form>
      <Table striped bordered hover variant="dark">
        <thead>
          <tr>
            <th>Date</th>
            <th>User ID</th>
            <th>Request Type</th>
            <th>Response Type</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          {logs && logs.length > 0 ? (
            logs.map((log) => (
              <tr key={log.id}>
                <td>{log.date}</td>
                <td>{log.userId}</td>
                <td>{log.requestType}</td>
                <td>{log.responseType}</td>
                <td>{log.message}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No logs found.</td>
            </tr>
          )}
        </tbody>
      </Table>
      <Pagination>{paginationItems}</Pagination>
    </Container>
  );
}

export default Logs;
